export default __webpack_public_path__ + "static/media/instructions-icepatch.e5a179c8.png";